"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SocketEventTypeEnum;
(function (SocketEventTypeEnum) {
    SocketEventTypeEnum["GET_ORDER"] = "GET_ORDER";
    SocketEventTypeEnum["GET_PREPAYMENT_ORDER"] = "GET_PREPAYMENT_ORDER";
    SocketEventTypeEnum["SAVE_ORDER_IIKO_SUCCESS"] = "SAVE_ORDER_IIKO_SUCCESS";
    SocketEventTypeEnum["SAVE_ORDER_IIKO_ERROR"] = "SAVE_ORDER_IIKO_ERROR";
    SocketEventTypeEnum["SAVING_IIKO_STATUS"] = "SAVING_IIKO_STATUS";
    SocketEventTypeEnum["CHANGED_ORDER_CURRENT_OPERATOR"] = "CHANGED_ORDER_OPERATOR";
    SocketEventTypeEnum["CHANGED_ORDER_OPERATORS"] = "CHANGED_ORDER_OPERATORS";
    //События для терминала
    SocketEventTypeEnum["CHANGE_PAYMENT_TERMINAL_ERROR"] = "CHANGE_PAYMENT_TERMINAL_ERROR";
    SocketEventTypeEnum["CHANGE_PAYMENT_TERMINAL_STAGE"] = "CHANGE_PAYMENT_TERMINAL_STAGE";
})(SocketEventTypeEnum = exports.SocketEventTypeEnum || (exports.SocketEventTypeEnum = {}));
//# sourceMappingURL=SocketEventTypeEnum.js.map